import {BaseCL} from "./generated/BaseCL";
import {UiFlashMessage} from "./UiFlashMessage";
import {CommonCL} from "./generated/CommonCL";
import {AnyElement, MuWidget} from "mu-widget/lib/MuWidget";
import {ColumnInfo} from "./components/UiTable";

export function getBaseCL() : CommonCL {
	// @ts-ignore
	const url : string = conf.baseCLUrl;
	return new CommonCL(url);
}

export class Arrays {
	static diff<T>(a1: T[], a2: T[]): T[] {
		return a1.filter(item => !a2.includes(item))
	}

	static intersect<T>(arr1: T[], arr2: T[]): T[] {
		return arr1.filter(value => arr2.includes(value));
	}


	static groupBy<T,TI extends string|number|symbol>(all: T[], getByField: (item:T) => TI): Record<TI, T[]> {
		const res: Record<TI, T[]> = {};
		for(const item of all) {
			const k = getByField(item);
			if (!(k in res)) res[k] = [];
			res[k].push(item);
		}
		return res;
	}

	static ToObject<TI, TK extends KeyTypes>(data: TI[], key: TK|((item: TI)=>TK), val: null|string|((item: TI)=>TK) = null): Record<TK, TI|any> {
		const res: Record<TK, TI|any> = {};
		for(const item of data) {
			const k = typeof key === "string"
				? item[key]
				: key(item);

			if (val === null) res[k] = item;
			else if (typeof item === "string") res[k] = item[key];
			else res[k] = key(item);
		}
		return res;
	}

	static unique<T>(items: T[]): T[] {
		return Array.from(new Set(items));
	}

	static ooaToArray<T>(items: T[]|T): T[] {
		return Array.isArray(items)
			? items
			: [ items ];
	}
}

export class Objects {
	public static swapKeysValues(obj: object) {
		const swapped: Record<any, any> = {};
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				swapped[obj[key]] = key;
			}
		}
		return swapped;
	}
}

export function copyToClipoard(content : string, type: "html"|"text" = "text") {
	const sx = window.scrollX;
	const sy = window.scrollY;
	const contentElement = document.createElement("div");
	if (type == "html") contentElement.innerHTML = content;
	else contentElement.innerText = content;
	// @ts-ignore
	document.getRootNode().firstElementChild.appendChild(contentElement);
	contentElement.contentEditable = "true";
	contentElement.setAttribute("contenteditable", "true");
	contentElement.focus();
	document.execCommand('selectAll');
	document.execCommand("copy");
	contentElement.parentElement.removeChild(contentElement);
	window.scrollTo(sx, sy);
	UiFlashMessage.instance.add("Zkopírováno do schránky");
	// alert("Zkopírováno do schránky");
}

export function strPadL(str: string, count: number, pad: string) {
	return str.length < count
		? pad.repeat(count - str.length) + str
		: str;
}

export function formatDateTime(d: Date|null, nullReplace: string = "") {
	return d
		? strPadL(d.getDate().toString(), 2, '0') + "."
			+ strPadL((d.getMonth() + 1).toString(), 2, '0') + "."
			+ d.getFullYear().toString() + " "
			+ strPadL(d.getHours().toString(), 2, "0") + ":"
			+ strPadL(d.getMinutes().toString(), 2, "0")
		: nullReplace;
}

export function flashError(message: string) {
	UiFlashMessage.instance.add(message);
}

export function flashInfo(message: string) {
	UiFlashMessage.instance.add(message);
}

export function changeElementOrder(element: AnyElement, rel: number) {
	if (rel < 0 && element.previousElementSibling) {
		element.parentElement.insertBefore(element, element.previousElementSibling);
	} else if (rel > 0 && element.nextElementSibling) {
		// element.parentElement.aft(element, element.nextElementSibling);
		element.nextElementSibling.after(element);
	}
}

export function indexBy<T,TI  extends keyof any>(arr : T[], keyCallback : ((T)=>TI)|string) : Record<TI,T> {
	let res : any = {};
	if (typeof keyCallback === 'string') {
		const key = keyCallback;
		keyCallback = item => item[key];
	}
	for(let item of arr) {
		res[keyCallback(item)] = item;
	}
	return res;
}

export function isOpenInNew(ev: MouseEvent) : boolean {
	return ev.ctrlKey ||
		ev.shiftKey ||
		ev.metaKey || // apple
		(ev.button && ev.button == 1)
}

export type KeyTypes = string|number|symbol;

export function formatDate(format: string, timestamp: number|Date): string {
	var that = { };
	var jsdate: Date;
	var f;
	// Keep this here (works, but for code commented-out below for file size reasons)
	// var tal= [];
	var txt_words = [
		'Sun', 'Mon', 'Tues', 'Wednes', 'Thurs', 'Fri', 'Satur',
		'January', 'February', 'March', 'April', 'May', 'June',
		'July', 'August', 'September', 'October', 'November', 'December'
	];
	// trailing backslash -> (dropped)
	// a backslash followed by any character (including backslash) -> the character
	// empty string -> empty string
	var formatChr = /\\?(.?)/gi;
	var formatChrCb = function(t, s) {
		return f[t] ? f[t]() : s;
	};
	var _pad = function(n: string, c: number) {
		n = String(n);
		while (n.length < c) {
			n = '0' + n;
		}
		return n;
	};
	f = {
		// Day
		d : function() {
			// Day of month w/leading 0; 01..31
			return _pad(f.j(), 2);
		},
		D : function() {
			// Shorthand day name; Mon...Sun
			return f.l()
				.slice(0, 3);
		},
		j : function() {
			// Day of month; 1..31
			return jsdate.getDate();
		},
		l : function() {
			// Full day name; Monday...Sunday
			return txt_words[f.w()] + 'day';
		},
		N : function() {
			// ISO-8601 day of week; 1[Mon]..7[Sun]
			return f.w() || 7;
		},
		S : function() {
			// Ordinal suffix for day of month; st, nd, rd, th
			var j = f.j();
			var i = j % 10;
			if (i <= 3 && parseInt((j % 100) / 10, 10) == 1) {
				i = 0;
			}
			return ['st', 'nd', 'rd'][i - 1] || 'th';
		},
		w : function() {
			// Day of week; 0[Sun]..6[Sat]
			return jsdate.getDay();
		},
		z : function() {
			// Day of year; 0..365
			var a = new Date(f.Y(), f.n() - 1, f.j());
			var b = new Date(f.Y(), 0, 1);
			return Math.round((a - b) / 864e5);
		},

		// Week
		W : function() {
			// ISO-8601 week number
			var a = new Date(f.Y(), f.n() - 1, f.j() - f.N() + 3);
			var b = new Date(a.getFullYear(), 0, 4);
			return _pad(1 + Math.round((a - b) / 864e5 / 7), 2);
		},

		// Month
		F : function() {
			// Full month name; January...December
			return txt_words[6 + f.n()];
		},
		m : function() {
			// Month w/leading 0; 01...12
			return _pad(f.n(), 2);
		},
		M : function() {
			// Shorthand month name; Jan...Dec
			return f.F()
				.slice(0, 3);
		},
		n : function() {
			// Month; 1...12
			return jsdate.getMonth() + 1;
		},
		t : function() {
			// Days in month; 28...31
			return (new Date(f.Y(), f.n(), 0))
				.getDate();
		},

		// Year
		L : function() {
			// Is leap year?; 0 or 1
			var j = f.Y();
			return j % 4 === 0 & j % 100 !== 0 | j % 400 === 0;
		},
		o : function() {
			// ISO-8601 year
			var n = f.n();
			var W = f.W();
			var Y = f.Y();
			return Y + (n === 12 && W < 9 ? 1 : n === 1 && W > 9 ? -1 : 0);
		},
		Y : function() {
			// Full year; e.g. 1980...2010
			return jsdate.getFullYear();
		},
		y : function() {
			// Last two digits of year; 00...99
			return f.Y()
				.toString()
				.slice(-2);
		},

		// Time
		a : function() {
			// am or pm
			return jsdate.getHours() > 11 ? 'pm' : 'am';
		},
		A : function() {
			// AM or PM
			return f.a()
				.toUpperCase();
		},
		B : function() {
			// Swatch Internet time; 000..999
			var H = jsdate.getUTCHours() * 36e2;
			// Hours
			var i = jsdate.getUTCMinutes() * 60;
			// Minutes
			// Seconds
			var s = jsdate.getUTCSeconds();
			return _pad(Math.floor((H + i + s + 36e2) / 86.4) % 1e3, 3);
		},
		g : function() {
			// 12-Hours; 1..12
			return f.G() % 12 || 12;
		},
		G : function() {
			// 24-Hours; 0..23
			return jsdate.getHours();
		},
		h : function() {
			// 12-Hours w/leading 0; 01..12
			return _pad(f.g(), 2);
		},
		H : function() {
			// 24-Hours w/leading 0; 00..23
			return _pad(f.G(), 2);
		},
		i : function() {
			// Minutes w/leading 0; 00..59
			return _pad(jsdate.getMinutes(), 2);
		},
		s : function() {
			// Seconds w/leading 0; 00..59
			return _pad(jsdate.getSeconds(), 2);
		},
		u : function() {
			// Microseconds; 000000-999000
			return _pad(jsdate.getMilliseconds() * 1000, 6);
		},

		// Timezone
		e : function() {
			// Timezone identifier; e.g. Atlantic/Azores, ...
			// The following works, but requires inclusion of the very large
			// timezone_abbreviations_list() function.
			/*              return that.date_default_timezone_get();
			 */
			throw 'Not supported (see source code of date() for timezone on how to add support)';
		},
		I : function() {
			// DST observed?; 0 or 1
			// Compares Jan 1 minus Jan 1 UTC to Jul 1 minus Jul 1 UTC.
			// If they are not equal, then DST is observed.
			var a = new Date(f.Y(), 0);
			// Jan 1
			var c = Date.UTC(f.Y(), 0);
			// Jan 1 UTC
			var b = new Date(f.Y(), 6);
			// Jul 1
			// Jul 1 UTC
			var d = Date.UTC(f.Y(), 6);
			return ((a - c) !== (b - d)) ? 1 : 0;
		},
		O : function() {
			// Difference to GMT in hour format; e.g. +0200
			var tzo = jsdate.getTimezoneOffset();
			var a = Math.abs(tzo);
			return (tzo > 0 ? '-' : '+') + _pad(Math.floor(a / 60) * 100 + a % 60, 4);
		},
		P : function() {
			// Difference to GMT w/colon; e.g. +02:00
			var O = f.O();
			return (O.substr(0, 3) + ':' + O.substr(3, 2));
		},
		T : function() {
			// Timezone abbreviation; e.g. EST, MDT, ...
			// The following works, but requires inclusion of the very
			// large timezone_abbreviations_list() function.
			/*              var abbr, i, os, _default;
			if (!tal.length) {
			  tal = that.timezone_abbreviations_list();
			}
			if (that.php_js && that.php_js.default_timezone) {
			  _default = that.php_js.default_timezone;
			  for (abbr in tal) {
				for (i = 0; i < tal[abbr].length; i++) {
				  if (tal[abbr][i].timezone_id === _default) {
					return abbr.toUpperCase();
				  }
				}
			  }
			}
			for (abbr in tal) {
			  for (i = 0; i < tal[abbr].length; i++) {
				os = -jsdate.getTimezoneOffset() * 60;
				if (tal[abbr][i].offset === os) {
				  return abbr.toUpperCase();
				}
			  }
			}
			*/
			return 'UTC';
		},
		Z : function() {
			// Timezone offset in seconds (-43200...50400)
			return -jsdate.getTimezoneOffset() * 60;
		},

		// Full Date/Time
		c : function() {
			// ISO-8601 date.
			return 'Y-m-d\\TH:i:sP'.replace(formatChr, formatChrCb);
		},
		r : function() {
			// RFC 2822
			return 'D, d M Y H:i:s O'.replace(formatChr, formatChrCb);
		},
		U : function() {
			// Seconds since UNIX epoch
			return jsdate / 1000 | 0;
		}
	};
	that.date = function(format, timestamp) {
		if (timestamp === undefined) jsdate = new Date();
		else if (timestamp instanceof Date || typeof timestamp === "string") jsdate = new Date(timestamp);
		else jsdate = new Date(timestamp * 1000); // UNIX timestamp (auto-convert to int)

		return format.replace(formatChr, formatChrCb);
	};
	return that.date(format, timestamp);
}

export function wrapElement(el: HTMLElement, tag: string): { original: HTMLElement, wrapper: HTMLElement }
{
	const res = {
		original: el,
		wrapper: document.createElement(tag),
	}
	// @ts-ignore
	res.original.parentElement.insertBefore(res.wrapper, res.original);
	// @ts-ignore
	res.original.parentElement.removeChild(res.original);
	res.wrapper.appendChild(res.original);

	return res;
}

export function focusFirstVisibleControl(el: HTMLElement|AnyElement): void
{
	const firstInput = el.querySelector('input,[tabindex],textarea,select') as HTMLElement;
	firstInput?.focus();

}

export function arrayDiff<T>(a: T[], b: T[]): T[] {
	return a.filter(x => !b.includes(x));
}

/* export function formatDate(dt: Date|string|null): string
{
	if (!dt) return "";
	if (typeof dt == "string") dt = new Date(dt);
	return formatNumber(dt.getDate(), 0, 2)
		+ "." + formatNumber(dt.getMonth() + 1, 0, 2)
		+ "." + dt.getFullYear()
		+ " " + formatNumber(dt.getHours(), 0, 2)
		+ ":" + formatNumber(dt.getMinutes(), 0, 2)
		+ ":" + formatNumber(dt.getSeconds(), 0, 2);
} */

export function formatNumber(value : number|null, decNumns : number|null = null, zeroPad : number = 0, decPoint : string = ",", nullText : string = "", thousandSeparator = "\xA0", thousandNums = 3) : string
{
	//todo: decNums, zeroPad, decPoint, nullText, thousandSeparator
	if (value === null || value === undefined) return nullText;
	var s : string;
	if (decNumns !== null)
	{
		var dd = Math.pow(10, decNumns);
		value = Math.round(value * dd) / dd;
		s = value.toString();
	}
	else
	{
		s = value.toString();
		var p = s.indexOf(".");
		if (p > -1) decNumns = s.length - (p + 1);
		else decNumns = 0;
	}

	var ip : string, dp : string = "";
	var p = s.indexOf(".");
	if (p > -1) {
		ip = s.substr(0, p);
		dp = s.substr(p + 1);
	}
	else ip = s;

	var ipl = ip.length;
	var dpl = dp.length;

	if (ipl < zeroPad)
	{
		ip = ip.padStart(zeroPad, "0"); // "0".repeat(zeroPad - ipl) + ip;
		ipl = zeroPad;
	}
	ip = " ".repeat(Math.ceil(ipl / thousandNums) * thousandNums - ipl) + ip;

	if (dpl < decNumns)
	{
		dp = dp.padEnd(decNumns, "0");
		dpl = decNumns;
	}

	function chunkStr(s : string, sep : string, size : number) : string
	{
		var l = s.length;
		if (l <= size) return s;
		var res = "";
		for(var i = 0; i < l; i += size)
		{
			if (res) res += sep;
			res += s.substr(i, size);
		}
		return res;
	}

	return chunkStr(ip, thousandSeparator, thousandNums).trim()
		+ (dpl > 0 ? decPoint + chunkStr(dp, thousandSeparator, thousandNums) : "");

}

export function removeEmptyProperties(src: Record<string|number, any>): Record<string|number, any>
{
	const res: Record<string|number, any> = {};
	for(const k in src) {
		if (src[k]) res[k] = src[k];
	}

	return res;
}

/**
 * Returns value of selected radio element
 * @param el
 */
export function getSelectedValue(el: HTMLInputElement): string|null {
	const form = el.form || document;
	// @ts-ignore
	for(const inEl of form.querySelectorAll('[name="' + el.name + '"]')) {
		if (inEl.checked) return inEl.value;
	}

	return null;
}

export function isHTMLStringEmpty(htmlString: string): boolean
{
	const tempDiv = document.createElement('div');
	if (tempDiv.querySelector('img,picture'))
		return true;
	tempDiv.innerHTML = htmlString;
	const textContent = tempDiv.textContent || tempDiv.innerText;

	return /^\s*$/.test(textContent);
}


export function setSelectedValue(el: HTMLInputElement, value: string|null): void {
	const form = el.form || document;
	// @ts-ignore
	for(const inEl of form.querySelectorAll('[name="' + el.name + '"]')) {
		inEl.checked = inEl.value == value;
	}
}

export function TCFormatDate(value: any, columnInf: ColumnInfo, cell: MuWidget) {
	if (value) {
		cell.container.title = formatDate("d.m.Y H:i", value);
		return formatDate("d.m.Y", value);
	}
	return '';
}

export function webalizeString(str: string) {
	const charlist = [
		['Á','A'], ['Ä','A'], ['Č','C'], ['Ç','C'], ['Ď','D'], ['É','E'], ['Ě','E'],
		['Ë','E'], ['Í','I'], ['Ň','N'], ['Ó','O'], ['Ö','O'], ['Ř','R'], ['Š','S'],
		['Ť','T'], ['Ú','U'], ['Ů','U'], ['Ü','U'], ['Ý','Y'], ['Ž','Z'], ['á','a'],
		['ä','a'], ['č','c'], ['ç','c'], ['ď','d'], ['é','e'], ['ě','e'], ['ë','e'],
		['í','i'], ['ň','n'], ['ó','o'], ['ö','o'], ['ř','r'], ['š','s'], ['ť','t'],
		['ú','u'], ['ů','u'], ['ü','u'], ['ý','y'], ['ž','z']
	];
	for (var i in charlist) {
		var re = new RegExp(charlist[i][0],'g');
		str = str.replace(re, charlist[i][1]);
	}

	str = str.replace(/[^a-z0-9]/ig, '-');
	str = str.replace(/\-+/g, '-');
	if (str[0] == '-') {
		str = str.substring(1, str.length);
	}
	if (str[str.length - 1] == '-') {
		str = str.substring(0, str.length - 1);
	}

	return str.toLowerCase();
}

export function escapeHtml(src: string): string {
	return Utils.escapeHtml(src);
}

export function createHtmlElement(name: string, attributes: Record<string, string>, innerText: string|null = ""): HTMLElement
{
	const el = document.createElement(name);
	for (const an in attributes) {
		el.setAttribute(an, attributes[an]);
	}
	if (innerText) el.innerText = innerText;

	return el;
}

// backcompatibility
export class Utils
{
	public static htmlOptions(values: Record<string, string>)
	{
		var html = "";
		for(var k in values)
		{
			html += "<option value=\"" + Utils.escapeHtml(k) + "\">" + Utils.escapeHtml(values[k]) + "</option>\n";
		}
		return html;
	}

	public static escapeHtml(src: string) {
		return src
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");
	}

	public static htmlListText(values: string[]): string
	{
		var html = "";
		for(var i = 0, l = values.length; i < l; i++)
		{
			html += "<li>" + Utils.escapeHtml(values[i]) + "</li>\n";
		}
		return html;
	}

	/* static getRecursiveItems(value: string | string[] | undefined, all: any[]) {
		const itemsByParentId = Arrays.groupBy(all, item => item.parentId);
		let res: any[] = [];
		let newIds = Array.isArray(value) ? value : [ value ];
		while (newIds.length > 0) {
			res = [ ...res, ...newIds ];
			let newNewIds = [];
			for(const id of newIds) {
				if (id in itemsByParentId) {
					newNewIds = [ ...newIds, ...itemsByParentId.map((item:any) => item.id) ]
				}
			}
		}
	} */

	static getRecursiveItems(arr: any[], id: number): number[] {
		const result: number[] = [];

		function findRecursively(parentId: number | null) {
			for (const item of arr) {
				if (item.parentId === parentId) {
					result.push(item.id);
					findRecursively(item.id);
				}
			}
		}

		findRecursively(id);

		return result;
	}

	static ajax(cmd, data, success, postData, error)
	{
		success = Utils.prepareCallback(success, this);
		if (error) error = Utils.prepareCallback(error, this);
		var ajaxOpts = {
			success: success,
			error: error
		}
		if (postData)
		{
			/* ajaxOpts.data = new FormData();
			for(var k in postData)
			{
				ajaxOpts.data.append(k, postData[k]);
			} */
			ajaxOpts.type = "post";
			ajaxOpts.data = postData;
		}
		$.ajax(
			this.getUrl(cmd, data),
			ajaxOpts
		);
	}

	getUrl(cmd, params)
	{
		var url = this.url[cmd];

		url = url.replace(/__([a-zA-Z0-9]+)__/g, (m, n) => params[n] ? params[n] : "");
		return url;
	}

	ajaxForm(form, done, prepare, opts)
	{
		done = Utils.prepareCallback(done, this);
		prepare = Utils.prepareCallback(prepare, this);

		form.addEventListener("submit", function()
		{
			if (opts == undefined) opts = {};
			event.preventDefault();
			var ajaxOpts = {
				url : opts.action || $(form).attr("action"),
				type: opts.method || $(form).attr("method"),
				data : new FormData(form),
				contentType: false,
				cache: false,
				processData:false
			};
			if (prepare) prepare(ajaxOpts);
			var ajaxRes = $.ajax(ajaxOpts);
			if (done) ajaxRes.done(done);
		});
	}

}

export async function loadUrlContent(url: string) {
	const f = fetch(url);
	return await (await f).text();
}

export function reviveLoadedElement(element: HTMLElement) {
	// init legacy parts
	element.querySelectorAll('script').forEach(el => eval(el.innerHTML));
	// @ts-ignore
	window.initAllSelectize(element);
	// @ts-ignore
	window.initInvoiceCreator();
}

export function jsNextCycle(): Promise<void> {
	return new Promise<void>(resolve => setTimeout(() => resolve(), 1));
}

export function pairsToList(o: Record<any, any>, kField: string = "id", vField: string = "name") {
	const res = [];
	for(const k in o) res.push({
		[kField]: k,
		[vField]: o[k],
	});

	return res;
}

export function getRadioListSelectedValue(el: HTMLInputElement): string|null {
	const container = el.form || document.documentElement;
	for(const iel of Array.from(container.querySelectorAll('input[name="' + el.name + '"]'))) {
		const ri = iel as HTMLInputElement;
		if (ri.checked) return ri.value;
	}
	return null;
}

export function sleepPromise(ms: number): Promise<void> {
	return new Promise(resolve => setTimeout(() => resolve(), ms));
}

export function changeClassStartsWith(classList: DOMTokenList, start: string, name: string|null)
{
	for(const t of classList) {
		if (t.startsWith(start)) classList.remove(t);
	}
	if (name) classList.add(start + name);
}

export function changeIconBefore(classList: DOMTokenList|HTMLElement, icon: string) {
	if (classList instanceof HTMLElement) classList = classList.classList;
	changeClassStartsWith(classList,'icon-before-', icon);
}

export function toDate(value: string|number|Date) {
	if (typeof value === "string") return new Date(value);
	if (typeof value === "number") throw "TODO: toDate/number";
	if (value instanceof Date) return value;
	throw "toDate: invalid value type";
}

/* BindFilters
export function forDateInput(value: string|number|Date): string {
	return toDate(value).toISOString().substring(0, 10);
} */

export function emptyToNull<T>(val: T): T|null {
	return val ? val : null;
}

export type YMPeriodMonth = 0|1|2|3|4|5|6|7|8|9|10|11;
export type YMPeriodPeriod = [ number, YMPeriodMonth ];

export class YMPeriod {
	public static toNum(y: number, m: YMPeriodMonth) {
		return y * 12 + m;
	}

	public static toInput(y: number, m: YMPeriodMonth | null = null) {
		if (m === null) {
			[y, m] = YMPeriod.toYM(y);
		}
		return y.toString().padStart(4, '0') + "-" + (m + 1).toString().padStart(2, '0');
	}

	public static toYM(p: number): [ number, YMPeriodMonth ] {
		return [
			Math.floor(p / 12),
			// @ts-ignore
			p % 12
		];
	}

	public static inputToNum(value: string): number|null {
		let [y, m] = value.split('-').map(a=>parseInt(a));
		m--;
		return value ? YMPeriod.toNum(y, m as YMPeriodMonth) : null;
	}

	public static inputToYM(value: string): YMPeriodPeriod|null {
		const n = YMPeriod.inputToNum(value);
		return n !== null ? YMPeriod.toYM(n) : null;
	}

	public static ymShift(y: number, m: YMPeriodMonth, shift: number): YMPeriodPeriod
	{
		return YMPeriod.toYM(YMPeriod.toNum(y, m) + shift);
	}

	static shift<T extends string|YMPeriodPeriod|number>(value: T, change: number): T {
		if (typeof value === "string") {
			const p = this.toNum(...this.inputToYM(value)) + change;
			return this.toInput(p);
		} else if (typeof value === "number") {
			return value + change;
		} else if (Array.isArray(value)) {
			return YMPeriod.ymShift(value, change);
		}
		throw "Invalid value";
	}
}

export function getBrightness(color: string|null): number|null {
	if (!color) return null;
	if (color[0] === "#") {
		color = color.substring(1);
		const bigint = parseInt(color, 16);
		const r = (bigint >> 16) & 255;
		const g = (bigint >> 8) & 255;
		const b = bigint & 255;
		color = `rgb(${r}, ${g}, ${b})`;
	}

	const values = color.match(/\d+/g).map(Number);
	const [r, g, b] = values;

	return (r * 299 + g * 587 + b * 114) / 1000;
}

export function oneShotHandler<T>(element: Node, eventType: string, callback: ((ev: Event) => T)|null = null): Promise<T|null>
{
	return new Promise((resolve) => {
		const handler = (ev: Event) => {
			element.removeEventListener(eventType, handler);
			resolve(callback ? callback(ev) : null);
		}
		element.addEventListener(eventType, handler);
	});
}

export function onDOMChanges(element: HTMLElement, callback: (ev:any)=>void): void {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
				callback(mutation);
			}
		});
	});

	observer.observe(element, { childList: true });
}

export function onDOMNodeRemoved(element: HTMLElement, callback: ()=>void): void {
	if (!element) {
		console.error(element);
	}
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				for (const node of mutation.removedNodes) {
					if (node === element || node.contains(element)) {
						observer.disconnect();
						callback();
					}
				}
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
}